export const excludedSource = [
    "Post-Standard",
    "Post-Standard_dev",
    "OR_Argus",
    "OR_Oregonian",
    "OR_OREGONIAN_dev",
    "CL_PDLiner",
    "cl_pdliner_dev",
    "PN_PATRIOT",
    "NJ_PJAHUNTERDON",
    "NJ_PJAHORSE",
    "PN_PJAHORSE",
    "NJ_PJAWARREN",
    "NJ_TRENTONTIMES",
    "NJ_JJOURNAL",
    "NJ_SOUTHJERSEY",
    "SI_SIADVANCE",
    "NJ_STARLEDGER",
    "NO_ONLINE_ADPAY_dev",
    "AL_HSVTIMES",
    "AL_PRESSREGISTER",
    "AL_BHAMNEWS",
    "NJ_TRENTONTIMES_dev",
    "MI_KLMZOO",
    "MI_GRRAPIDS",
    "MI_SAGINAW",
    "MI_MUSKEGON",
    "MI_ADVNWSP",
    "MI_ANNARBOR",
    "MI_JACKSON",
    "MI_FLINT",
    "MI_BAYCITY",
    "al_pressregister_dev",
    "MA_REPUBLICAN",
    "ma_republican_dev",
    "SI_SIADVANCE_dev",
    "NJ_STARLEDGER_dev",
    "AL_BHAMNEWS_dev",
    "MI_GRRAPIDS_dev",
    "MI_MUSKEGON_dev",
    "MI_BAYCITY_dev",
    "MI_SAGINAW_dev",
    "MI_ANNARBOR_dev",
    "MI_JACKSON_dev",
    "MI_KLMZOO_dev",
    "PN_PATRIOT_dev",
    "AL_BHAMNEWS_OPENHOUSES_dev",
    "AL_BHAMNEWS_OPENHOUSES",
    "NJ_JJOURNAL_dev",
    "NJ_SOUTHJERSEY_dev",
    "mi_flint_dev",
    "nj_pjahorse_dev",
    "nj_pjawarren_dev",
    "nj_pjahunterdon_dev",
    "pn_pjahorse_dev",
    "AL_HSVTIMES_dev",
    "NJ_PJASUBURB_INDEP_dev",
    "NJ_PJASUBURB_INDEP",
    "LVL_EXPRESS_dev",
    "LVL_EXPRESS",
    "AL_OPENHSEDISPLAY_dev",
    "AL_OPENHSEDISPLAY",
    "NJ_PJAMESSENGER_dev",
    "NJ_PJAMESSENGER",
    "GL_PRESSREGISTER_dev",
    "GL_PRESSREGISTER",
    "GL_AdPay_dev",
    "GL_AdPay",
    "MI_ADVNWSP_dev",
    "OR_ARGUS_DEV",
    "NJ_jaye_daily_news",
    "SYR_Test_Newspaper_dev",
    "MI_DETROIT_dev",
    "MI_DETROIT",
    "MI_LANSING_dev",
    "MI_LANSING",
    "MI_NMICHIGAN_dev",
    "MI_NMICHIGAN",
    "NJ_EXPRESS_dev",
    "NJ_EXPRESS",
];
export const excludedProperty = [
    "_ADPAY",
    "_AGENTFINDER",
    "_BHI",
    "_BHHS",
    "_COLDWELL",
    "_HOWARDH",
    "_WEICHERT",
    "AL_REALTYSOUTH",
    "MA_MASIELLOGROUP_LH",
    "MI_REALONE",
    "MI_REMAX",
    "MI_REMAXSEMI",
    "MI_REMERICA",
    "MI_TOMIE",
    "NJ_LONGFOSTER_LH",
    "NJ_REMAX",
    "PN_JGAUGHEN",
    "PN_JGAUGHEN_RENT",
];
// // //only affiliates with leadformcredentials will use new lead form
export const leadFormCredentials = {
    "nj": "QUt6-iu78FIxyB74D",
    "mlive": "56PZQnjZKVv20S8-y",
    "cleveland": "EjDLrLKOfWsUrTLeW",
    "pennlive": "_8Qf2MLfzBvf1-pmc",
    "masslive": "vgBxiR_HAN8K1A_IC",
    "silive": "uauKvs2q_6LbJSuqf",
    "lehighvalleylive": "WdcIAHgRaI-QBwV2B",
    "syracuse": "3RAWHwkYWwP-DQEdC",
    "gulflive": "YqWmkada4K65Bizmi",
    "al": "-KE6yhD4RUhKej2nS",
}
// // test api key
// export const leadFormCredentials = {
    // "nj": "pOqH8u6FzgmxDbJUv",
    // "mlive": "kWD0scAWY1wKvSokT",
    // "cleveland": "VmH2AouSwdOnvw_cA",
    // "pennlive": "zqnovNWcWQ1rEEXBj",
    // "al": "jJKg_i1ns0hNQcioV",
    // "masslive": "RKEDagtlZjYVJBdTt",
    // "silive": "DMdf1Icsk-3PA8gDr",
    // "syracuse": "QjfHMUmMtbymXwC0z",
    // "gulflive": "KRLCLmkJBkrEPIeqe",
    // "lehighvalleylive": "MV84ENJZwFUl0TSYJ"
// }
// prod api key
// export const leadFormCredentials = {
//     "nj": "QUt6-iu78FIxyB74D",
//     "mlive": "56PZQnjZKVv20S8-y",
//     "cleveland": "EjDLrLKOfWsUrTLeW",
//     "pennlive": "_8Qf2MLfzBvf1-pmc",
//     "al": "-KE6yhD4RUhKej2nS",
//     "masslive": "vgBxiR_HAN8K1A_IC",
//     "silive": "uauKvs2q_6LbJSuqf",
//     "syracuse": "3RAWHwkYWwP-DQEdC",
//     "gulflive": "YqWmkada4K65Bizmi",
//     "lehighvalleylive": "WdcIAHgRaI-QBwV2B",
// }
export const leadFormPhoneNumbers = {
    "nj": "1-855-449-2017",
    "mlive": "1-855-449-2041",
    "cleveland": "1-855-449-0493",
    "pennlive": "1-855-449-1807",
    "al": "1-855-449-0938",
    "masslive": "1-855-459-2641",
    "silive": "1-855-459-2585",
    "syracuse": "1-855-459-2370",
    "gulflive": "1-855-460-1253",
    "lehighvalleylive": "1-855-459-2659",
}
export const listHubSource = {
    "nj": "advance-local-nj-buyer-ldp",
    "mlive": "advance-local-mlive-buyer-ldp",
    "cleveland": "advance-local-cleveland-buyer-ldp",
    "pennlive": "advance-local-pennlive-buyer-ldp",
    "al": "advance-local-al-buyer-ldp",
    "masslive": "advance-local-masslive-buyer-ldp",
    "silive": "advance-local-silive-buyer-ldp",
    "syracuse": "advance-local-syracuse-buyer-ldp",
    "gulflive": "advance-local-gulflive-buyer-ldp",
    "lehighvalleylive": "advance-local-lehighvalleylive-buyer-ldp",
}
